import type { ScreenModule } from "../../../app/screen-module";
import { PasswordResetPage } from "../auth-pages";

export default {
	id: "public.password-reset",
	path: "/password-reset",
	area: "public",
	label: "パスワード再設定",
	roles: [],
	backing: "MOCK_ONLY",
	enabled: true,
	component: PasswordResetPage,
} satisfies ScreenModule;
